import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import FormikRadio from '../../../base/forms/formikRadio';
import InactiveStep from '../../InactiveStep';
import { useMultiStepFormContext } from '../../context/multistepContext';
import { useTranslationsContext } from '../../context/translationsContext';
import { FormStepProps } from '../../sendReceiptMultistep';
import {
	ButtonWrapper,
	FormStepHeading,
	FormStepWrapper,
	PrevButton,
	PrevButtonMobile,
	ProceedButton,
} from '../../sendReceiptMultistep.styles';

export const SHIPMENT_STEP_INDEX = 2;
export default function Shipment({ values, setFieldValue, touched, setFieldTouched, errors }: FormStepProps) {
	const translations = useTranslationsContext();
	const { currentStepIndex, latestStepIndexVisited, next, prev, goTo } = useMultiStepFormContext();
	const { t } = useTranslation('sendReceiptMultistep');

	useEffect(() => {
		if (values.instructionsToStaff === 'hasInvoice' && values.hasReceipt !== 'Yes') {
			setFieldValue('hasReceipt', 'Yes');
		} else if (values.instructionsToStaff !== 'hasInvoice' && values.hasReceipt !== 'No') {
			setFieldValue('hasReceipt', 'No');
		}
	}, [values.instructionsToStaff, values.hasReceipt, setFieldTouched, setFieldValue]);

	if (currentStepIndex !== SHIPMENT_STEP_INDEX && latestStepIndexVisited >= SHIPMENT_STEP_INDEX)
		return (
			<InactiveStep
				heading={translations?.inactiveTitles?.shipment || t('inactiveTitles.shipment')}
				onClick={() => goTo(SHIPMENT_STEP_INDEX)}
				touched={touched}
				errors={errors}
			/>
		);

	const isStepComplete = values.instructionsToStaff && !errors.instructionsToStaff;

	if (currentStepIndex === SHIPMENT_STEP_INDEX)
		return (
			<FormStepWrapper>
				<PrevButtonMobile
					onClick={e => {
						e.stopPropagation();
						prev();
					}}
					>
					{translations?.prevStepMobile || t('prevStepMobile')}
				</PrevButtonMobile>
				<FormStepHeading>
					{translations?.formStepTitles?.shipment || t('formStepTitles.shipment')}
				</FormStepHeading>
				<FormikFieldWrapper name="instructionsToStaff" languageComponent="sendReceipt" marginBottom="1rem">
					<FormikRadio
						id="hasInvoice"
						name="instructionsToStaff"
						label={translations?.shipment?.hasInvoice || t('shipment.hasInvoice')}
						setFieldValue={setFieldValue}
					/>
					<FormikRadio
						id="openUp"
						name="instructionsToStaff"
						label={translations?.shipment?.openUp || t('shipment.openUp')}
						setFieldValue={setFieldValue}
					/>
					<FormikRadio
						id="alreadyCleared"
						name="instructionsToStaff"
						label={translations?.shipment?.alreadyCleared || t('shipment.alreadyCleared')}
						setFieldValue={setFieldValue}
					/>
					<FormikRadio
						id="gift"
						name="instructionsToStaff"
						label={translations?.shipment?.gift || t('shipment.gift')}
						setFieldValue={setFieldValue}
					/>
					<FormikRadio
						id="other"
						name="instructionsToStaff"
						label={translations?.shipment?.other || t('shipment.other')}
						setFieldValue={setFieldValue}
					/>
				</FormikFieldWrapper>
				<ButtonWrapper>
					<PrevButton
						onClick={e => {
							e.stopPropagation();
							prev();
						}}
						>
						{translations?.prevStep || t('prevStep')}
					</PrevButton>
					<ProceedButton
						type="button"
						onClick={e => {
							e.stopPropagation();
							next();
						}}
						disabled={!isStepComplete}>
						{translations?.nextStep || t('nextStep')}
					</ProceedButton>
				</ButtonWrapper>
			</FormStepWrapper>
		);

	return null;
}
